/**
 * pspCredentialsApi — cliente del registro de credenciales de PSP por compañía
 * expuesto por payment (ADR-015). payment es el ÚNICO que cifra/descifra y toca
 * la tabla credenciales_psp; tadmin solo llama a `GET/POST /api/psp-credentials`
 * con el JWT de sesión de Clerk del staff (payment valida email @yooldigital.com).
 *
 * La respuesta de list NUNCA trae el secreto en claro (solo api_key enmascarada).
 * La URL de yoolpay se deriva del hostname en runtime (ver baseUrl.js).
 */

import { yoolpayBaseUrl } from './baseUrl.js';

const YOOLPAY_BASE_URL = yoolpayBaseUrl();

async function request(path, token, options = {}) {
  const res = await fetch(`${YOOLPAY_BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(body?.error || `payment respondió ${res.status}`);
  }
  return body;
}

/** Lista las credenciales (enmascaradas) de una compañía. */
export async function listPspCredentials(token, companiaId) {
  const body = await request(
    `/api/psp-credentials?companiaId=${encodeURIComponent(companiaId)}`,
    token,
  );
  return body.credenciales ?? [];
}

/**
 * Registra (o rota) credenciales de PSP de una compañía. payment las cifra.
 * payload: { companiaId, proveedor, ambiente, apiKey, secretKey, apiBase?, merchantId?,
 *            config?: { plan_id?, collection_account?, ... } }
 * config: bag genérico de params de ruteo por-PSP NO secretos (jsonb). VirtualPOS
 * usa config.plan_id (plan PROGRAMA_DE_PAGOS a reutilizar para las suscripciones de
 * pago propio); Toku usará config.collection_account; etc.
 */
export async function savePspCredentials(token, payload) {
  return request('/api/psp-credentials', token, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
